module.exports = "/_next/static/images/bd359fa0acb8cceb0cb1a77bd3fdc933-pj-woman-working@0.5x.jpg";